import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PricingCard } from './PricingCard';
import { ServerLocationSelector } from './ServerLocationSelector';

import { Gamepad2, Zap } from 'lucide-react';

export function GameServerPlans() {
  const { t } = useTranslation();

  // Unico gioco disponibile (non usato direttamente ma lo lascio)
  const selectedGame = 'minecraft';

  // Tabs: "game" = Standard (ECO), "performance" = Performance (Ryzen 7 9700X)
  const [selectedCategory, setSelectedCategory] = useState<'game' | 'performance'>('game');

  const location = 'falkenstein';

  const categories = [
    {
      id: 'game',
      icon: Gamepad2,
      title: t('gameHosting.categories.standard.title'),
      description: t('gameHosting.categories.standard.description'),
    },
    {
      id: 'performance',
      icon: Zap,
      title: t('gameHosting.categories.performance.title'),
      description: t('gameHosting.categories.performance.description'),
    },
  ];

  // ---------- STANDARD (ECO) ----------
  const standardPlans = [
    {
      title: 'ECO-1',
      price: '€1,40',
      specs: [
        'CPU: Xeon 1 vCore @ 3.80 GHz',
        'RAM: 2GB',
        'Storage: 5GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-1',
    },
    {
      title: 'ECO-2',
      price: '€2,80',
      specs: [
        'CPU: Xeon 1 vCore @ 3.80 GHz',
        'RAM: 4GB',
        'Storage: 10GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-2',
    },
    {
      title: 'ECO-3',
      price: '€2,80',
      specs: [
        'CPU: Xeon 2 vCore @ 3.80 GHz',
        'RAM: 5GB',
        'Storage: 15GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-3',
    },
    {
      title: 'ECO-4',
      price: '€4,20',
      specs: [
        'CPU: Xeon 2 vCore @ 3.80 GHz',
        'RAM: 6GB',
        'Storage: 20GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-4',
    },
    {
      title: 'ECO-5',
      price: '€5,60',
      specs: [
        'CPU: Xeon 3 vCore @ 3.80 GHz',
        'RAM: 8GB',
        'Storage: 25GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-5',
    },
    {
      title: 'ECO-6',
      price: '€7,00',
      specs: [
        'CPU: Xeon 3 vCore @ 3.80 GHz',
        'RAM: 10GB',
        'Storage: 30GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-6',
    },
    {
      title: 'ECO-7',
      price: '€8,40',
      specs: [
        'CPU: Xeon 4 vCore @ 3.80 GHz',
        'RAM: 12GB',
        'Storage: 35GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-7',
    },
    {
      title: 'ECO-8',
      price: '€9,80',
      specs: [
        'CPU: Xeon 4 vCore @ 3.80 GHz',
        'RAM: 14GB',
        'Storage: 40GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-8',
    },
    {
      title: 'ECO-9',
      price: '€11,20',
      specs: [
        'CPU: Xeon 5 vCore @ 3.80 GHz',
        'RAM: 16GB',
        'Storage: 45GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-9',
    },
    {
      title: 'ECO-10',
      price: '€12,60',
      specs: [
        'CPU: Xeon 5 vCore @ 3.80 GHz',
        'RAM: 18GB',
        'Storage: 50GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-10',
    },
    {
      title: 'ECO-11',
      price: '€14,00',
      specs: [
        'CPU: Xeon 6 vCore @ 3.80 GHz',
        'RAM: 20GB',
        'Storage: 55GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-11',
    },
    {
      title: 'ECO-12',
      price: '€15,40',
      specs: [
        'CPU: Xeon 6 vCore @ 3.80 GHz',
        'RAM: 22GB',
        'Storage: 60GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-12',
    },
    {
      title: 'ECO-13',
      price: '€16,40',
      specs: [
        'CPU: Xeon 7 vCore @ 3.80 GHz',
        'RAM: 24GB',
        'Storage: 65GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-13',
    },
    {
      title: 'ECO-14',
      price: '€18,20',
      specs: [
        'CPU: Xeon 7 vCore @ 3.80 GHz',
        'RAM: 26GB',
        'Storage: 70GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-14',
    },
    {
      title: 'ECO-15',
      price: '€19,20',
      specs: [
        'CPU: Xeon 8 vCore @ 3.80 GHz',
        'RAM: 28GB',
        'Storage: 75GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-15',
    },
    {
      title: 'ECO-16',
      price: '€21,00',
      specs: [
        'CPU: Xeon 8 vCore @ 3.80 GHz',
        'RAM: 30GB',
        'Storage: 80GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-16',
    },
    {
      title: 'ECO-17',
      price: '€22,40',
      specs: [
        'CPU: Xeon 8 vCore @ 3.80 GHz',
        'RAM: 32GB',
        'Storage: 85GB NVMe',
        'Database: illimitati',
        'Player slots: illimitati',
        'Protezione DDoS: avanzata',
        'Supporto: 24/7',
        'NOC: 12/6 ordinario, 24/7 emergenze',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/minecraft-eco-hosting/eco-17',
    },
  ];

  // ---------- PERFORMANCE (vecchi standard, ora Ryzen 7 9700X + DDR5) ----------
  const performancePlans = [
    {
      title: 'Performance Nano',
      price: '€2.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 2GB DDR5',
        'Storage: 20GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 10 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/nano',
    },
    {
      title: 'Performance Micro',
      price: '€4.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 3GB DDR5',
        'Storage: 30GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 15 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/micro',
    },
    {
      title: 'Performance Basic',
      price: '€6.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 4GB DDR5',
        'Storage: 40GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 20 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/basic',
    },
    {
      title: 'Performance Advanced',
      price: '€9.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 6GB DDR5',
        'Storage: 50GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 30 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/advanced',
    },
    {
      title: 'Performance Pro',
      price: '€14.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 8GB DDR5',
        'Storage: 60GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 40 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/pro',
    },
    {
      title: 'Performance Elite',
      price: '€19.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 12GB DDR5',
        'Storage: 80GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 60 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/elite',
    },
    {
      title: 'Performance Ultra',
      price: '€24.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 16GB DDR5',
        'Storage: 100GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 80 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/ultra',
    },
    {
      title: 'Performance Extreme',
      price: '€34.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 24GB DDR5',
        'Storage: 150GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 120 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/extreme',
    },
    {
      title: 'Performance Ultimate',
      price: '€49.99',
      specs: [
        'CPU: AMD Ryzen 7 9700X',
        'RAM: 32GB DDR5',
        'Storage: 200GB NVMe',
        'Traffico illimitato',
        'Protezione DDoS',
        'Supporto 24/7',
        'Fino a 200 giocatori',
      ],
      buyLink: 'https://my.synthohosting.net/index.php?rp=/store/gameserver-performance/ultimate',
    },
  ];

  const currentPlans = selectedCategory === 'game' ? standardPlans : performancePlans;

  return (
    <div className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Category Selection */}
        <div className="flex gap-4 mb-8">
          {categories.map((category) => {
            const Icon = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id as typeof selectedCategory)}
                className={`flex-1 p-4 rounded-lg transition-all ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-white border border-gray-200 hover:border-blue-300'
                }`}
              >
                <div className="flex items-center gap-3 mb-2">
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{category.title}</span>
                </div>
                <p className="text-sm opacity-80">{category.description}</p>
              </button>
            );
          })}
        </div>

        <div className="mb-8">
          <ServerLocationSelector selectedLocation={location} onLocationChange={() => {}} />
        </div>

        {/* PLANS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {currentPlans.map((plan, index) => (
            <PricingCard
              key={index}
              {...plan}
              isPopular={index === 4}
              variant="standard"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
